export const projectsData = [
  {
    name: "Vconnect",
    tech: "React Js ,Node Js,Express ,Mongo Db ,Bootstrap",
    details: "Vconnect is a web platform made for students of VIT chennai to connect with each other for cab sharing. The user can create a post specifying their requirement. This automatically creates a group chat which others users can join and chat with the creator. See the repo for more details.",
    thumb: "vconnect.jpg",
    links: {
      live: "https://github.com/HimanshuBarak/VConnect",
      repo: "https://github.com/HimanshuBarak/VConnect"
    }
  },
  {
    name: "Package Updater",
    tech: "Node js , Octokit, Github Tokens",
    details: "Package updater is a CLI tool using which the user can check if their dependencies version for a given package are below a certain threshold or not.This tool allows users to automatically  create a new pull request to update the dependency's version.",
    thumb: "package_updater.png",
    links: {
      live: "https://github.com/HimanshuBarak/Package-Updater",
      repo: "https://github.com/HimanshuBarak/Package-Updater"
    }
  },
  {
    name: "Beez",
    tech: "React Js ,Node Js,Express ,InterSystem FHIR API ,Tangram ,Bootstrap,CSS",
    details: "I made this project during HackMIT with my teammates. The web app allows women to track and predict all reproductive phases using a trained machine learning model. By allowing users to opt-in to share their data with researchers - Beez hopes to facilitate research in women's health. My team won the first prize in the InterSystems challenge for this project :).",
    thumb: "beez.png",
    links: {
      live: "https://openexchange.intersystems.com/package/Beez-Woman-Menstrual-Tracker",
      repo: "https://github.com/katiele47/beez_menstrual_tracker_hackmit"
    }
  },

  {
    name: "Bookify",
    tech: "React Js ,Google Books API,Bootstrap,CSS",
    details: "Bookify is online book information retrival system.It fetches all the book information using the google books API. The user can search the title of their choice and get all the information regarding those titles.The user also have the option to preview book on Google Books. ",
    thumb: "bookify.JPG",
    links: {
      live: "https://findnovels.netlify.app/",
      repo: "https://github.com/HimanshuBarak/Bookify"
    }
  },

  {
    name: "Netflix Clone",
    tech: "React Js ,Bootstrap,CSS,TMDB API",
    details: "This is a simple netflix clone that I made while learning React.It uses the tmdb API to pull in information about trending movies and tv shows. Along with this you can play trailers of movies and tv shows. It uses react-youtube package to play youtube trailers of selected movies when clicked on. ",
    thumb: "netflix.JPG",
    links: {
      live: "https://netflic-clone-cbacb.web.app/",
      repo: "https://github.com/HimanshuBarak/Netflix-clone"
    }
  },

  {
    name: "Home Security",
    tech: "React Js ,CSS ,Firebase",
    details: "I made this project as my Jcomponent for my Distributed Real Time System Course. I have used firebase authentication and firebase firestore database for this project alongside with React Js. 10 secs after the user logins sensor data for 3 sensors is generated randomly and send to firebase database. If the value of the sensors is greater than threshold values than a alert is displayed in the console. ",
    thumb: "homesecurity.JPG",
    links: {
      live: "https://security-ff744.web.app/",
      repo: "https://github.com/HimanshuBarak/HomeSecurity"
    }
  },

  {
    name: "Swades Properties Website",
    tech: "HTML,CSS,Firebase",
    details: "This is the official website for Swades Properties. The clients can fill thier enquires.These enquires are stored in firestore and are fetched using a different website by the Swades Properties employees.",
    thumb: "swades.JPG",
    links: {
      live: "https://swadesproperties.in/",
      repo: "https://github.com/HimanshuBarak/swades"
    }
  },
   
  
];


export const writingsData = [
  {
    title: "Understanding How React.js Works Under the Hood",
    publishedOn: "Medium",
    link: "https://medium.owaspvit.com/understanding-how-react-js-works-under-the-hood-be14d13beaa6"
  },
  {
    title: "Everything about the sort() function in STL Library",
    publishedOn: "Medium",
    link: "https://medium.com/@himanshubarak/everything-about-the-sort-function-in-stl-library-338bdd73c184"
  },
  {
    title: "Why is a deployemnt pattern named after a bird?",
    publishedOn: "Linkedin",
    link: "https://www.linkedin.com/posts/himanshubarak_canarydeployment-softwaredevelopment-deployments-activity-7103327883539980288-ZQ9w?utm_source=share&utm_medium=member_desktop"
  },
  {
    title: "Why do S3 buckets name have to be globally unique?",
    publishedOn: "Linkedin",
    link: "https://www.linkedin.com/posts/himanshubarak_aws-amazons3-cloudsecurity-activity-7100915144926359553-HrZ0?utm_source=share&utm_medium=member_desktop"
  },
  {
    title: "How does Amazon Prime display actor names in realtime?",
    publishedOn: "Linkedin",
    link: "https://www.linkedin.com/posts/himanshubarak_linkedin-activity-7082052397941878784-uMlP?utm_source=share&utm_medium=member_desktop"
  },
  {
    title: "Some interesting limitations of various AWS Resources",
    publishedOn: "Linkedin",
    link: "https://www.linkedin.com/posts/himanshubarak_aws-limitations-architecture-activity-7066019844340543489-QJCx?utm_source=share&utm_medium=member_desktop"
  },
  
  
];


// WEBPACK FOOTER //
// ./src/data/data.js